(function () {
    'use strict';

    angular
        .module('app.dailySetup')
        .run(appRun);

    appRun.$inject = ['routerHelper', 'opsIncludeVersion'];
    /* @ngInject */
    function appRun(routerHelper, opsIncludeVersion) {
        routerHelper.configureStates(getStates(opsIncludeVersion));
    }

    function getStates(opsIncludeVersion) {
        return [
              {
                  state: 'dailysetup',
                  config: {
                      url: '/dailysetup',
                      title: 'Daily Setup',
                      settings: {
                          nav: 50,
                          content: '<i class="fa fa-calendar-check-o"></i> <span class="leftNavText">Daily Setup</span>',
                          authMode: 1,
                          requireOps: true,
                          mobileButton: true
                      },
                      resolve: {
                          authenticationRequired: ['userService', function (userService) {
                              userService.isAuthenticatedThrowError();
                          }]
                      },
                      views: {
                          "": {
                              templateUrl: 'app/dailySetup/reactDailySetup.html?v=' + opsIncludeVersion ,
                              controller: 'ReactDailySetupController',
                              controllerAs: 'vm',
                          }
                      }

                  }
              }

              

        ];
    }
})();
